import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { RouteName } from '@/router/route-names';
import useLoginData from '@/common/composition/useLoginData';

const { getLoginData } = useLoginData();

const AuthenticationGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const loginData = await getLoginData();

  if (to.meta.mustBeLoggedIn && !loginData.isLoggedIn) {
    next({
      name: RouteName.LoginIndex,
      query: { returnUrl: from?.fullPath },
    });
    return;
  }

  next();
};

export default AuthenticationGuard;
